import { MDBBtn, MDBCheckbox, MDBChip } from "mdb-react-ui-kit";
import React from "react";
import { formattedNumber } from "../AddRemoveNumbers";

function ReviewNumbers({
  register,
  watch,
  portingNumbers,
  handlePreviousClick,
  portingType,
}) {
  return (
    <>
      <div className="pb-3">
        <div className="d-flex align-items-center justify-content-between w-100 pe-3">
          <div>
            <h5>Review Number(s)</h5>
            <p>
              Telephone Number(s) added{" "}
              {portingType === 3 ? "for Validation" : "to Transfer"}:
            </p>
          </div>
          <MDBBtn
            onClick={(e) => {
              e.preventDefault();
              handlePreviousClick();
            }}
          >
            Edit Numbers
          </MDBBtn>
        </div>

        <div className="border-bottom d-flex flex-column align-items-center justify-content-between w-100">
          <div className="d-flex w-100 sm-w-100 flex-wrap gap-2 tnPortingNumbers border border-2  p-2">
            <div>
              {portingNumbers &&
                portingNumbers?.length > 0 &&
                portingNumbers?.map((number) => (
                  <MDBChip key={number} className="m-chip d-inline py-2 px-3">
                    {formattedNumber(number)}
                  </MDBChip>
                ))}
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center mt-3">
          <span id="flexCheckDefault">
            {portingNumbers.length} number
            {portingNumbers?.length > 1 ? "(s) are" : " is"} ready for{" "}
            {portingType === 3 ? "Validation" : "Transfer"}
          </span>
        </div>
      </div>
    </>
  );
}

export default ReviewNumbers;
